// TODO move all to shared utils and doc

import { isFuture, isToday } from "date-fns"

export function getLastMonday() {
  const today = new Date()
  const dayOfWeek = today.getDay()
  const diff = (dayOfWeek + 6) % 7
  const lastMonday = new Date(today)
  lastMonday.setDate(today.getDate() - diff)
  return lastMonday
}

export function addDays(date: Date, days: number) {
  const newDate = new Date(date)
  newDate.setDate(newDate.getDate() + days)
  return newDate
}

/**
 * Generates an array of dates in ISO 8601 format, starting from a specific date.
 *
 * @param {Date} startDate - The starting date from which the dates will be generated.
 * @param {number} numberOfDays - The number of consecutive days to generate, including the start date.
 *
 * @returns {string[]} An array of strings representing dates in ISO 8601 format.
 *
 * @example
 * // Example usage:
 * const startDate = new Date('2025-01-01');
 * const numberOfDays = 3;
 * const datesArray = getDatesArray(startDate, numberOfDays);
 * console.log(datesArray);
 * // Output: ['2025-01-01T00:00:00.000Z', '2025-01-02T00:00:00.000Z', '2025-01-03T00:00:00.000Z']
 *
 * @note Requires the `addDays` function to add days to the starting date.
 */
export function generateDateArray(startDate: Date, numberOfDays: number): string[] {
  const dates = []
  for (let i = 0; i < numberOfDays; i++) {
    const nextDate = addDays(startDate, i)
    dates.push(nextDate.toISOString())
  }
  return dates
}

export const isCurrentDay = (dateToCheck: string) => {
  const today = new Date()
  const date = new Date(dateToCheck)

  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  )
}

export function getDraggableDay(dateTime: string) {
  const isDraggableDay = isToday(new Date(dateTime)) || isFuture(new Date(dateTime))
  return isDraggableDay
}
